(ns app.front.view.group.admin.inspections.quick-pick-deficiencies
  (:require [app.domain.group.config.model :as config-model]
            [app.domain.group.permit-type-config.model :as ptc-model]
            [app.domain.inspection.model :as inspection-model]
            [app.domain.workspace.model :as workspace-model]
            [app.front.entities :as entities]
            [app.front.ui :as ui]
            [app.front.ui.action-buttons :as ui-action-buttons]
            [app.front.ui.content-switcher :as content-switcher]
            [app.front.ui.rich-text :as ui-rt]
            [app.front.ui.select :as ui-select]
            [app.front.ui.sortable-table :as sortable-table]
            [app.front.view.group.admin.feature-toggle :as feature-toggle]
            [app.front.view.group.admin.permit-type-select :as permit-type-select]
            [app.front.view.group.admin.subs :as gas]
            [app.front.view.inspections.deficiencies-v2 :as deficiencies-v2]
            [app.rich-text :as rich-text]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub >evt]]
            [core.front.icons :as i]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))

(def qpd-section->title-tr
  {:active [:inspection/pick-list]
   :draft  [:inspection/pick-list-draft]})

(rf/reg-sub ::displayed-qpd-section
  (fn [db _]
    (get db ::displayed-qpd-section :active)))

(rf/reg-event-db ::set-displayed-qpd-section
  (fn [db [_ section]]
    (assoc db ::displayed-qpd-section section)))

(rf/reg-sub ::template-kinds-for-config
  :<- [::entities/context]
  (fn [context [_ config-tuple]]
    (when (> (count config-tuple) 1)
      (let [permit-type    (first config-tuple)
            leaf-config-id (last config-tuple)]
        (->> leaf-config-id
             (entities/find-entity context)
             (workspace-model/leaf->config-path permit-type)
             (config-model/keep-as-set :group.config/inspection-templates)
             (map :entity/parent)
             (sort-by :ordered/order))))))

(rf/reg-event-db ::select-template-kind-id
  (fn [db [_ template-kind-id]]
    (assoc db ::selected-template-kind-id template-kind-id)))

(rf/reg-sub ::selected-template-kind-id
  :-> ::selected-template-kind-id)

(rf/reg-event-db ::select-config-tuple
  (fn [db [_ config-tuple]]
    (assoc db ::selected-config-tuple config-tuple)))

(rf/reg-sub ::selected-config-tuple
  :-> ::selected-config-tuple)

(rf/reg-event-fx ::fetch-active-qpds
  (fn [_ [_ template-kind-id group-config-id]]
    {:comm/command {:command    :inspection/get-active-quick-pick-deficiencies
                    :method     :get
                    :data       (util/mmap template-kind-id group-config-id)
                    :on-success [::entities/merge-entity-db]}}))

(rf/reg-event-fx ::edit-qpd
  (fn [_ [_ id changes]]
    {:comm/command {:command    :inspection/edit-quick-pick-deficiency
                    :method     :post
                    :data       (util/mmap id changes)
                    :on-success [::entities/apply-changes]
                    :notify     {:success :changes-saved}}}))

(rf/reg-event-fx ::reorder-qpds
  (fn [_ [_ from-id to-id template-kind-version]]
    {:comm/command {:command    :inspection/reorder-quick-pick-deficiencies
                    :method     :post
                    :data       (util/mmap from-id to-id template-kind-version)
                    :on-success [::entities/apply-changes]}}))

(rf/reg-event-db ::toggle-qpd-expansion
  (fn [db [_ id]]
    (update db ::expanded-qpd-ids util/toggle-in-set id)))

(rf/reg-sub ::expanded-qpd-ids
  :-> ::expanded-qpd-ids)

(rf/reg-event-db ::start-editing-qpd
  (fn [db [_ id]]
    (assoc-in db [::editing-qpd-ids id] {})))

(rf/reg-event-db ::cancel-editing-qpd
  (fn [db [_ id]]
    (update db ::editing-qpd-ids dissoc id)))

(rf/reg-sub ::editing-qpd-ids
  :-> ::editing-qpd-ids)

(rf/reg-event-db ::store-qpd-edits
  (fn [db [_ id changes]]
    (update-in db [::editing-qpd-ids id] merge changes)))

(rf/reg-event-db ::clear-qpd-tables-state
  (fn [db _]
    (-> db
        (dissoc ::expanded-qpd-ids ::editing-qpd-ids)
        (assoc-in [::draft-qpds :selected-draft-qpd-ids] #{}))))

(rf/reg-event-fx ::persist-qpd-edits
  (fn [{:keys [db]} [_ id]]
    (let [changes (get-in db [::editing-qpd-ids id])]
      {:fx [[:dispatch [::edit-qpd id changes]]
            [:dispatch [::cancel-editing-qpd id]]]})))

(rf/reg-sub ::draft-qpds
  :-> ::draft-qpds)

(rf/reg-event-db ::set-draft-qpds-date-range
  (fn [db [_  from-or-to date]]
    (assoc-in db [::draft-qpds :date-range from-or-to] date)))

(rf/reg-event-db ::clear-draft-qpds-date-range
  (fn [db _]
    (assoc-in db [::draft-qpds :date-range] {})))

(rf/reg-sub ::draft-qpds-from-date
  :<- [::draft-qpds]
  :-> #(-> % :date-range :from))

(rf/reg-sub ::draft-qpds-to-date
  :<- [::draft-qpds]
  :-> #(-> % :date-range :to))

(rf/reg-sub ::has-more-draft-qpds-to-fetch?
  :<- [::draft-qpds]
  :-> :has-more-to-fetch?)

(rf/reg-event-db ::toggle-selected-draft-qpd
  (fn [db [_ id]]
    (update-in db [::draft-qpds :selected-draft-qpd-ids]
               util/toggle-in-set id)))

(rf/reg-event-db ::clear-selected-draft-qpd-ids
  (fn [db _]
    (assoc-in db [::draft-qpds :selected-draft-qpd-ids] #{})))

(rf/reg-sub ::selected-draft-qpd-ids
  :<- [::draft-qpds]
  :-> :selected-draft-qpd-ids)

(rf/reg-event-fx ::fetch-draft-qpds
  (fn [_ [_ data]]
    {:comm/command {:command    :inspection/get-draft-quick-pick-deficiencies
                    :method     :get
                    :data       data
                    :on-success [::fetch-draft-qpds.success]}}))

(rf/reg-event-fx ::fetch-draft-qpds.success
  (fn [{:keys [db]} [_  status {:keys [entities has-more?]}]]
    {:db       (assoc-in db [::draft-qpds :has-more-to-fetch?] has-more?)
     :dispatch [::entities/merge-entity-db status entities]}))

(rf/reg-event-fx ::activate-qpds
  (fn [_ [_ ids]]
    {:comm/command {:command    :inspection/activate-quick-pick-deficiencies
                    :method     :post
                    :data       (util/mmap ids)
                    :on-success [::activate-qpds.success]
                    :notify     {:success :changes-saved}}}))

(rf/reg-event-fx ::activate-qpds.success
  (fn [_ [_ status changes]]
    {:fx [[:dispatch [::entities/apply-changes status changes]]
          [:dispatch [::clear-selected-draft-qpd-ids]]]}))

(defn active-qpds-section [template-kind group-config-id authority-group-id tr]
  (let [expanded-qpd-ids (<sub [::expanded-qpd-ids])
        editing-qpd-ids  (<sub [::editing-qpd-ids])
        qpds             (when (and template-kind group-config-id)
                           (inspection-model/active-quick-pick-deficiencies template-kind group-config-id))]
    (if (empty? qpds)
      [:p (tr [:deficiencies/quick-pick-list-empty])]
      [sortable-table/table
       {:id                "active-qpds-table"
        :items             qpds
        :cols              [[(tr [:deficiencies/reference])
                             (fn [qpd]
                               (let [id        (:db/id qpd)
                                     reference (:inspection.quick-pick-deficiency/reference qpd)]
                                 (if (contains? expanded-qpd-ids id)
                                   [ui-rt/editor-legacy {:id                 (str "reference-editor-" id "-" (hash reference))
                                                         :label-text         (tr [:deficiencies/reference])
                                                         :label-class        "font-bold"
                                                         :initial-value      reference
                                                         :on-change          (when (contains? editing-qpd-ids id)
                                                                               #(>evt
                                                                                  [::store-qpd-edits id
                                                                                   {:inspection.quick-pick-deficiency/reference %}]))
                                                         :authority-group-id authority-group-id}]
                                   (ui/summarize-description (rich-text/join-rich-text-content reference) 100))))
                             {:max-width "25rem"}]
                            [(tr [:deficiencies/description])
                             (fn [qpd]
                               (let [id          (:db/id qpd)
                                     description (:inspection.quick-pick-deficiency/description qpd)]
                                 (if (contains? expanded-qpd-ids id)
                                   [ui-rt/editor-legacy {:id                 (str "description-editor-" id "-" (hash description))
                                                         :label-text         (tr [:deficiencies/description])
                                                         :label-class        "font-bold"
                                                         :initial-value      description
                                                         :on-change          (when (contains? editing-qpd-ids id)
                                                                               #(>evt
                                                                                  [::store-qpd-edits id
                                                                                   {:inspection.quick-pick-deficiency/description %}]))
                                                         :authority-group-id authority-group-id}]
                                   (ui/summarize-description (rich-text/join-rich-text-content description) 250))))]]
        :expanded-row-keys expanded-qpd-ids
        :expanded-func     (fn [{:db/keys [id]}]
                             [:div.flex.justify-end
                              [ui/modal-confirmation-button
                               {:id                  (str "delete-qpd-" id)
                                :tr                  tr
                                :modal-title         (tr [:deficiencies/delete-title])
                                :trigger-button-text (tr [:delete])
                                :trigger-button-opts {:icon          i/trash
                                                      :icon-position :right
                                                      :size          :small
                                                      :kind          :tertiary
                                                      :class-name    "mr-2"}
                                :on-yes-click        #(>evt [::edit-qpd id
                                                             {:domain/state :inspection.quick-pick-deficiency.state/removed}])}
                               [:span (tr [:deficiencies/confirm-delete?])]]
                              (if-not (contains? editing-qpd-ids id)
                                [ui/button {:kind     :secondary
                                            :size     :small
                                            :on-click #(>evt [::start-editing-qpd id])}
                                 (tr [:edit])]
                                [ui-action-buttons/save-cancel-buttons
                                 {:on-cancel      #(>evt [::cancel-editing-qpd id])
                                  :on-save        #(>evt [::persist-qpd-edits id])
                                  :save-disabled? (empty? (get editing-qpd-ids id))
                                  :size           :small
                                  :tr             tr}])])
        :on-expand         #(do (>evt [::toggle-qpd-expansion %])
                                (>evt [::cancel-editing-qpd %]))
        :on-reorder        (fn [from to]
                             (>evt [::reorder-qpds (:db/id from) (:db/id to) (:entity/version template-kind)]))
        :tr                tr}])))

(defn draft-qpds-section [template-kind group-config-id tr]
  (let [from-date        (<sub [::draft-qpds-from-date])
        to-date          (<sub [::draft-qpds-to-date])
        dates-selected?  (and from-date to-date)
        has-more?        (<sub [::has-more-draft-qpds-to-fetch?])
        qpds             (when (and template-kind group-config-id dates-selected?)
                           (inspection-model/draft-quick-pick-deficiencies template-kind group-config-id from-date to-date))
        template-kind-id (:db/id template-kind)
        fetch-draft-qpds (fn [args]
                           (let [params (merge (util/mmap template-kind-id group-config-id from-date to-date)
                                               args)]
                             (when (and (:from-date params) (:to-date params) (:offset params))
                               (>evt [::fetch-draft-qpds params]))))
        selected-qpd-ids (<sub [::selected-draft-qpd-ids])]
    [:<>
     (when-not dates-selected?
       [:div.mb-4 (tr [:deficiencies/quick-pick-list-draft-info])])
     [:div.flex.gap-4.items-end.mb-6
      [ui/date-picker
       {:id         "qpd-from-date"
        :label-text (tr [:inspection/pick-list-draft-from-date])
        :max-date   (or to-date (date-util/now))
        :value      from-date
        :callback   (fn [date]
                      (let [from (date-util/start-of-day date)]
                        (>evt [::clear-qpd-tables-state])
                        (>evt [::set-draft-qpds-date-range :from from])
                        (fetch-draft-qpds {:from-date from
                                           :offset    0})))}]
      [ui/date-picker
       {:id         "qpd-to-date"
        :label-text (tr [:inspection/pick-list-draft-to-date])
        :max-date   (date-util/now)
        :min-date   from-date
        :value      to-date
        :callback   (fn [date]
                      (let [to (date-util/end-of-day date)]
                        (>evt [::clear-qpd-tables-state])
                        (>evt [::set-draft-qpds-date-range :to to])
                        (fetch-draft-qpds {:to-date to
                                           :offset  0})))}]]
     (when dates-selected?
       (if (empty? qpds)
         [:p (tr [:deficiencies/quick-pick-list-empty])]
         [:div
          [deficiencies-v2/quick-pick-deficiencies-table
           qpds tr selected-qpd-ids #(>evt [::toggle-selected-draft-qpd %])]
          (when has-more?
            [:div.flex.justify-center.mt-4.mb-2
             [ui/button {:kind     :tertiary
                         :size     :small
                         :on-click #(fetch-draft-qpds {:offset (count qpds)})}
              (tr [:show-more])]])
          [:div.flex.gap-4.justify-between.items-center.mt-4
           [:div
            (when (> (count selected-qpd-ids) 1)
              [ui/button {:kind     :tertiary
                          :size     :small
                          :on-click #(>evt [::clear-selected-draft-qpd-ids])}
               (tr [:multi-select/select-none])])]
           [ui/button {:kind     :primary
                       :disabled (empty? selected-qpd-ids)
                       :on-click #(>evt [::activate-qpds selected-qpd-ids])}
            (tr [:inspection/pick-list-add])]]]))]))

(defn view [{:keys [authority-group-id tr]}]
  (let [lang                          (<sub [:language])
        permit-types-with-inspections (->> (<sub [::gas/group-permit-types])
                                           (filter ptc-model/permit-types-with-inspections))
        primary-permit-type           (<sub [::gas/group-primary-permit-type])
        selected-config-tuple         (or (not-empty (<sub [::selected-config-tuple]))
                                          [primary-permit-type])
        config-tuple->leaf-id         #(-> % rest last)
        selected-leaf-group-config-id (config-tuple->leaf-id selected-config-tuple)
        template-kinds                (<sub [::template-kinds-for-config selected-config-tuple])
        selected-template-kind-id     (<sub [::selected-template-kind-id])
        selected-template-kind        (<sub [::entities/entity selected-template-kind-id])
        displayed-qpd-section         (<sub [::displayed-qpd-section])
        fetch-active-qpds             (fn [template-kind-id config-id]
                                        (when (and template-kind-id config-id)
                                          (>evt [::clear-qpd-tables-state])
                                          (>evt [::clear-draft-qpds-date-range])
                                          (>evt [::fetch-active-qpds template-kind-id config-id])))]
    [:section
     [feature-toggle/toggle-group-feature (util/mmap {:feature-name :group.feature/deficiency-quick-pick-list-public-display
                                                      :feature-flag :feature-flag.id/deficiency-quick-pick-list}
                                                     tr)]
     [:h3.mt-6.mb-4 (tr [:inspection/pick-list-configuration])]
     [ui/help (tr [:inspection/quick-pick-config-help]) {:color :blue}]
     [:div.mb-8
      [permit-type-select/permit-type-select
       (util/mmap {:selectable-permit-types permit-types-with-inspections
                   :selected-tuple          selected-config-tuple
                   :on-change               (fn [config-tuple]
                                              (>evt [::select-config-tuple config-tuple])
                                              (when (not= config-tuple selected-config-tuple)
                                                (fetch-active-qpds selected-template-kind-id
                                                                   (config-tuple->leaf-id config-tuple))))}
                  tr)]]
     [ui-select/select {:id           "template-kind-select"
                        :class        "w-full max-w-xl mb-8"
                        :label-text   (tr [:inspection/type])
                        :value        selected-template-kind
                        :values       template-kinds
                        :val->str     #(inspection-model/inspection-template-kind-name % lang)
                        :allow-empty? false
                        :on-change    (fn [{:db/keys [id]}]
                                        (>evt [::select-template-kind-id id])
                                        (fetch-active-qpds id selected-leaf-group-config-id))}]
     (when (and selected-template-kind selected-leaf-group-config-id)
       [:<>
        [:div.mb-6
         [content-switcher/content-switcher
          {:items     (keys qpd-section->title-tr)
           :val->str  #(tr (qpd-section->title-tr %))
           :current   displayed-qpd-section
           :on-change #(do
                         (>evt [::clear-qpd-tables-state])
                         (>evt [::set-displayed-qpd-section %]))}]]
        (if (= displayed-qpd-section :active)
          [active-qpds-section selected-template-kind selected-leaf-group-config-id authority-group-id tr]
          [draft-qpds-section selected-template-kind selected-leaf-group-config-id tr])])]))
